module.exports = __webpack_public_path__ + "static/sample-projects-4-afc971439e58ddeeb896c94ff25fc219.png";